import React from 'react';
import classNames from 'classnames';
import store from '@src/store/index.js';

import './Nav.css';

function LogoutConfirm() {
  return (
    <div className="logoutConfirmContent">
      <h2 className="popupTitle">Logout</h2>
      <p>This action will cause you to leave any current scenario session and return to the login screen.</p>
      <p>Is that what you want to do?</p>
      <div className="popupBtnGroup">
        <button className="btn popupBtn" onClick={() => store.logout()}>Confirm</button>
        <button className="btn popupBtn" onClick={() => store.closePopup('logout')}>Cancel</button>
      </div>
    </div>
  );
}

function onLogoutBtnClick() {
  // Only open popup if inside a session
  if (store.isInSession()) {
    store.openPopup('logout', LogoutConfirm);
  } else {
    store.logout();
  }
}

export default function Nav(props) {
  const userData = store.user.useSelector(user => user.data);
  const userName = store.connection.useSelector(connection => connection.userName);
  const nameTag = store.getIdentity();
  return (
    <div className={classNames('navContainer', props.className)} ref={props.innerRef}>
      <div className="frame navFrame">
        <div className="navInfo">
          <div>Logged in as: </div>
          <div className="navInfoNameTag">{nameTag}</div>
        </div>
        <button className="btn navBtn" onClick={onLogoutBtnClick}>Logout</button>
      </div>
    </div>
  );
}
